module.exports = __webpack_public_path__ + "static/img/lxsemicon-renewal2025.e150876.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lxsemicon-renewal2025.jpg
// module id = SKBg
// module chunks = 0